module.exports = __webpack_public_path__ + "static/media/green-tours.91f2f0d9.png";